import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";
import DeleteIcon from "@mui/icons-material/DeleteForeverRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { RAIL_LABEL } from "../../../constants/configuration.const";
import DragHandleIcon from "@mui/icons-material/DragIndicator";
import LockIcon from "@mui/icons-material/Lock";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import axios from "../../../utils/axiosInstance";
import { useSnackbar } from "notistack";
import { Button, Tooltip } from "@mui/material";
import BannerForm, { dynamicBannerValidationSchema } from "./BannerForm";

const HeroContentCurationCard = forwardRef(
    (
        {
            onClickDelete,
            onClickEdit,
            onClickAdd,
            data,
            className,
            hideAddButton,
            playlist,
            handleBanners,
            videos,
            videoAPILoader,
            allowEdit,
            setHeroBannerValidation,
            heroBannerStatus,
        }: any,
        ref: any
    ) => {
        useImperativeHandle(
            ref,
            () => ({
                isValid,
                getFormValues: () =>
                    (bannerListRef && bannerListRef.current.getFormValues()) ||
                    null,
                submitHeroBanner: () =>
                    (bannerListRef &&
                        bannerListRef.current.handleSubmitFormik()) ||
                    null,
                onOpenBanner,
            }),
            []
        );

        // hooks
        const [showBannerList, setShowBannerList] = useState(false);
        const { enqueueSnackbar } = useSnackbar();
        const bannerListRef = useRef<any>(null);
        const [bannerInfoDraft, setBannerInfoDraft] = useState<any>(null);
        const [errorMessage, setErrorMessage] = useState("");

        useEffect(() => {
            heroBannerStatus(showBannerList);
        }, [showBannerList]);

        const onOpenBanner = () => {
            setShowBannerList(true);
        };

        const onCloseBanner = () => {
            const { isValidForm, getFormValues } = bannerListRef.current;
            const banners = getFormValues()?.banners || [];
            setHeroBannerValidation(isValidForm(), banners);
            setBannerInfoDraft(banners);
            setShowBannerList(false);
        };

        const isValid = () => {
            debugger;
            if (bannerListRef.current) {
                return bannerListRef.current.isValidForm();
            } else {
                const formValid = validateInput(data);
                return formValid?.isValid == null ? null : formValid?.isValid;
            }
        };

        const validateInput = (inputJson: any) => {
            try {
                const validCheck =
                    dynamicBannerValidationSchema.validateSync(inputJson);
                return { isValid: true, values: validCheck };
            } catch (error) {
                return { isValid: false, values: inputJson };
            }
        };

        const saveBanners = () => {
            const { isValidForm, getFormValues, handleSubmitFormik } =
                bannerListRef.current;
            const validForm = isValidForm();
            if (validForm) {
                enqueueSnackbar("Banner Added", {
                    variant: "info",
                    autoHideDuration: 2000,
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                setBannerInfoDraft(null);
                setHeroBannerValidation(true, null);
                setErrorMessage("");
                setShowBannerList(false);
                handleSubmitFormik();
            } else {
                setErrorMessage("Please fill all the required fields");
            }
        };

        return (
            <div
                className={
                    "curation-list-card-container d-flex j-center curation-card"
                }
            >
                <div className="d-flex float-center">
                    {className == "curation-card" ? (
                        <DragHandleIcon className="drag-handle" />
                    ) : (
                        <LockIcon className="drag-handle" />
                    )}
                </div>
                <div className="curation-list-card hero-carousal-card-height">
                    {/* Row One */}
                    <div className="d-flex j-space">
                        <span className="curation-title">
                            #{RAIL_LABEL[data.template]}
                        </span>
                        <div className="f-bold">{data.railTitle}</div>
                        <div>
                            {allowEdit && (
                                <Tooltip title="Delete">
                                    <span
                                        className="cursor-pointer delete-circle-style"
                                        onClick={onClickDelete}
                                    >
                                        <DeleteIcon />
                                    </span>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    {/* row content */}
                    {showBannerList && (
                        <BannerForm
                            allowEdit={allowEdit}
                            videoAPILoader={videoAPILoader}
                            draft={bannerInfoDraft}
                            banners={data?.banners}
                            ref={bannerListRef}
                            videos={videos}
                            playlist={playlist}
                            handleBanners={handleBanners}
                        />
                    )}

                    <div className="mt-3 d-flex j-space">
                        {!showBannerList && (
                            <>
                                <span
                                    onClick={onOpenBanner}
                                    className="curation-edit cursor-pointer"
                                >
                                    Edit Rail
                                </span>
                                <KeyboardArrowDownIcon
                                    className="cursor-pointer"
                                    onClick={onOpenBanner}
                                />
                            </>
                        )}
                    </div>

                    {showBannerList && (
                        <div className="d-flex flex-column">
                            <div className="d-flex j-end">
                                {allowEdit && (
                                    <Button
                                        onClick={saveBanners}
                                        className="max-content-width float-center align-right mr-2"
                                        variant="contained"
                                        type="button"
                                    >
                                        Save Banner
                                    </Button>
                                )}
                                <KeyboardArrowUpIcon
                                    className="align-right cursor-pointer"
                                    onClick={onCloseBanner}
                                />
                            </div>
                            {errorMessage && (
                                <div className="text-danger d-flex j-end publish-error-text">
                                    {errorMessage}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="curation-list-card-container-span">
                    {!hideAddButton && allowEdit && (
                        <Tooltip title="Add New Rail">
                            <span
                                className="cursor-pointer add-circle-style"
                                onClick={onClickAdd}
                            >
                                <AddCircleOutlineIcon />
                            </span>
                        </Tooltip>
                    )}
                </div>
            </div>
        );
    }
);

export default HeroContentCurationCard;
